import styled from 'styled-components';

import Button from '../../../../../components/Button';

const ActiveStreamSettingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const DeleteButton = styled(Button)`
  align-self: flex-start;
  width: auto;
  margin: ${({ theme }) => theme.spacing(1, 0)};
`;

export { ActiveStreamSettingContainer, DeleteButton };
